module.exports = __webpack_public_path__ + "assets/img/help_tenBtn.996ddd9c.png";